import {Injectable} from '@angular/core';
import {Mapper} from '../../../../core/abstracts/mapper.abstract';
import {BrandResponse} from '../../../../shared/services/brand.service';
import {Brand} from '../models/brand.model';

@Injectable({providedIn: 'root'})
export class VehicleBrandResponseMapper extends Mapper<BrandResponse, Brand> {

  override map(source: BrandResponse): Brand {
    return new Brand(source.id, source.name);
  }
}
